/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersonalUserDataItem } from '../models/PersonalUserDataItem';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PersonalUserDataService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Add a new user with personal data
     * @param userId of the given user to fetch the personal data for
     * @returns any Ok
     * @throws ApiError
     */
    public getPersonalUserDataItem(
        userId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/personalUserData/{userId}',
            path: {
                'userId': userId,
            },
        });
    }

    /**
     * update a given user data for the given user id
     * @param userId
     * @param requestBody the updated user data
     * @returns void
     * @throws ApiError
     */
    public updatePersonalUserDataItem(
        userId: string,
        requestBody: PersonalUserDataItem,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/personalUserData/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
